import { DomainCode } from '@australiangreens/ag-internal-components';
import { logger } from '@/util';
import callBackendApi from './call';

export interface EventRecord {
  id: number;
  title: string;
  startDate: string;
}

export const getEventsByIds = async (
  token: string,
  ids: number[],
  domainCode: DomainCode,
  abortSignal?: AbortSignal
) => {
  logger.debug('getEventsByIds() called', {});

  const data = await callBackendApi({
    token,
    method: 'get',
    endpoint: `/events?ids=${JSON.stringify(ids)}&domainCode=${domainCode}`,
    abortSignal,
  });
  return data as EventRecord[];
};

export const getEventsContaining = async (
  token: string,
  containedString: string,
  domainCode: DomainCode,
  abortSignal?: AbortSignal
) => {
  logger.debug('getEventsContaining() called', {});

  const data = await callBackendApi({
    token,
    method: 'get',
    endpoint: `/events/containing/${encodeURIComponent(containedString)}?domainCode=${domainCode}`,
    abortSignal,
  });
  return data as EventRecord[];
};
